import type { PreferredCourtsValues } from 'utils/shared/playerFinder';
import { AvailabilityField } from 'components/PlayerFinder';
import ProfileFormModal from './ProfileFormModal';
import type { ProfileEditorModalProps } from './types';
import { useModalDraft } from './useModalDraft';

interface Props extends ProfileEditorModalProps {
  defaultValues: PreferredCourtsValues | null;
  onSave: (values: PreferredCourtsValues) => Promise<boolean>;
}

export default function PreferredTimeFormModal({
  isOpen,
  onClose,
  defaultValues,
  onSave,
  isSaving,
  error,
}: Props) {
  const { values, setValues, handleSave } = useModalDraft(isOpen, defaultValues, onSave, onClose);

  return (
    <ProfileFormModal
      isOpen={isOpen}
      onClose={onClose}
      title="Preferred time to play"
      description="Pick the days you usually play, then the times that suit you."
      onSave={handleSave}
      isSaving={isSaving}
      error={error}
    >
      {values && (
        <AvailabilityField
          days={values.days}
          timesByDay={values.timesByDay}
          onChange={(next) => setValues({ ...values, ...next })}
        />
      )}
    </ProfileFormModal>
  );
}
